import { render, staticRenderFns } from "./recentMoreLiveCourse.vue?vue&type=template&id=b5ac486c&scoped=true&"
import script from "./recentMoreLiveCourse.vue?vue&type=script&lang=js&"
export * from "./recentMoreLiveCourse.vue?vue&type=script&lang=js&"
import style0 from "./recentMoreLiveCourse.vue?vue&type=style&index=0&id=b5ac486c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ac486c",
  null
  
)

export default component.exports